import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackEvent } from '../monitoring/tracking'

const { version } = require('../../package.json')

export const useCacheBuster = () => {
  const location = useLocation()
  const path = location.pathname.split("/").length === 2 ? "./" : "../" // TODO: if we go more than 2 layers deep on the location we will need to change this logic

  const parseVersion = (str) => +str.replace(/\D/g, '')

  useEffect(() => {
    fetch(`${path}meta.json?v=${+new Date()}`, { cache: 'no-cache' })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          throw new Error('Response is not JSON');
        }
        return response.json();
      })
      .then((meta) => {
        if (meta?.version) {
          const metaVersion = parseVersion(meta.version);
          const packageVersion = parseVersion(version);
          if (packageVersion < metaVersion) {
            if (window?.location?.reload) {
              window.location.reload()
            }
          }
        }
      })
      .catch((error) => {
        // Silently fail in development when meta.json doesn't exist
        // In production, meta.json is generated during build
      });
  }, [location])

  return null
}